<script setup lang="ts">
interface Column {
  title: string
}

defineProps<{
  columns: Column[]
}>()
</script>

<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        v-for="(column, index) in columns"
        :key="index"
        scope="col"
        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ column.title }}
      </th>
    </tr>
  </thead>
</template>
